// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"aa76fa69","453":"8323f319","455":"b01b80e1","977":"dbd802c2"}[chunkId] + ".chunk.js";
};